import React from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import EmailConfirmation from "../components/EmailConfirmation"
import Footer from "../components/Footer"
import Header from "../components/Header"
import Home from "../pages/Home"
import NotFound from "../pages/NotFound"
import PrivacyPolicy from "../pages/PrivacyPolicy"
import PrescriptionAudit from "../pages/PrescriptionAudit"
import TermsOfUse from "../pages/TermsOfUse"

function AppRoutings() {
  return (
    <Router>
      <Header />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/user/confirm" component={EmailConfirmation} />
        <Route path={["/prescription-audit/:metarxId", "/pa-enroll-now/:metarxId"]} component={PrescriptionAudit} />
        <Route exact path="/regional-ambassador-agreement" component={TermsOfUse} />
        <Route path="*" component={NotFound} />
      </Switch>
      <Footer />
    </Router>
  )
}

export default AppRoutings
